import axios from 'axios';
import { message } from 'antd';
import { getItem, removeItem } from '../../utility/localStorageControl';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const getToken = () => {
  const user = getItem('user');
  return user?.tokens?.access?.token;
};

const getSucursalId = () => {
  const sucursal = getItem('sucursal');
  return sucursal?.id;
};

const authHeader = () => {
  const token = getToken();
  const sucursalId = getSucursalId();
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  
  // Agregar header de sucursal si existe
  if (sucursalId) {
    headers['x-sucursal-id'] = sucursalId;
  }
  
  return headers;
};

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
  },
});

class DataService {
  static get(path = '') {
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static delete(path = '') {
    return client({
      method: 'DELETE',
      url: path,
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use(config => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  const sucursalId = getSucursalId();
  
  requestConfig.headers = { 
    ...headers, 
    Authorization: `Bearer ${getToken()}`,
    ...(sucursalId && { 'x-sucursal-id': sucursalId })
  };

  return requestConfig;
});

client.interceptors.response.use(
  response => response,
  error => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    if (response) {
      if (response.status !== 200) {
        message.error(response?.data?.message || 'Ha ocurrido un error');
        console.log('Error', response?.data?.message);

        if (response?.data?.code === 401 && response?.data?.message === 'Necesitas Autenticarte') {
          removeItem('user');
          window.location.reload();
          return false;
        }
        return Promise.reject(response.data);
      }
      return response.data;
    }
    message.error('Ha ocurrido un error de conexión');

    return Promise.reject(error);
  },
);
export { DataService };
